import { ICommandBase } from "@Quest/cqrs";

export class CreateStrategyCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Strategies.Commands.CreateStrategyCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	Id: string;
	Name: string;
	Description: string;

	constructor(workspaceId: number, strategyId: string, name: string, description: string)
	{
		this.WorkspaceId = workspaceId;		
		this.Id = strategyId;
		this.Name = name;
		this.Description = description;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Strategies.Commands.CreateStrategyCommandV1, TCh.Domain.Quest'
	}
}
export class DeleteStrategyCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Strategies.Commands.DeleteStrategyCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	Id: string;

	constructor(workspaceId: number, strategyId: string)
	{
		this.WorkspaceId = workspaceId;
		this.Id = strategyId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Strategies.Commands.DeleteStrategyCommandV1, TCh.Domain.Quest'
	}
}

export class UpdateStrategySettingsCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Strategies.Commands.UpdateStrategySettingsCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	Id: string; 
	Name: string;
	Description: string;
	Currency: string;
	DefaultPnlId: string;
	IncludeCogs: boolean;
	IncludeOpex: boolean;
	IncludeOther: boolean;
	FiscalYearStartMonth: number;

	constructor(workspaceId: number, strategyId: string, name: string, description: string, currency: string, defaultPnlId: string, 
		includeCogs: boolean, includeOpex: boolean, includeOther: boolean, fiscalYearStartMonth: number)
	{
		this.WorkspaceId = workspaceId;
		this.Id = strategyId;
		this.Name = name;
		this.Description = description;
		this.Currency = currency;
		this.DefaultPnlId = defaultPnlId;
		this.IncludeCogs = includeCogs;
		this.IncludeOpex = includeOpex;
		this.IncludeOther = includeOther;
		this.FiscalYearStartMonth = fiscalYearStartMonth;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Quest.Strategies.Commands.UpdateStrategySettingsCommandV1, TCh.Domain.Quest';
	}
}
export class TriggerMetricUpdatesCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Strategies.Commands.TriggerMetricUpdatesCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	Id: string;

	constructor(workspaceId: number, id: string)
	{
		this.WorkspaceId = workspaceId;
		this.Id = id;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Strategies.Commands.TriggerMetricUpdatesCommandV1, TCh.Domain.Quest';
	}
}

export class UpdateResourceUnitCostsCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Strategies.Commands.UpdateResourceUnitCostsCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	Id: string;
	FromYear: number;
	Entries: string[];

	constructor(workspaceId: number, strategyId: string, fromYear: number, entries: string[])
	{
		this.WorkspaceId = workspaceId;
		this.Id = strategyId;
		this.FromYear = fromYear;
		this.Entries = entries;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Strategies.Commands.UpdateResourceUnitCostsCommandV1, TCh.Domain.Quest'
	}
}

export class CreateCorporateProjectPlanTemplateCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Strategies.Commands.CreateCorporateProjectPlanTemplateCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	Id: string;
	TemplateId: string;
	Name: string;
	Description: string | null;
	PlanningHorizonInYears: number;
	DurationInMonths: number;
	Granularity: string;
	Denomination: string;

	constructor(workspaceId: number, strategyId: string, templateId: string, name: string, description: string | null,
		planningHorizonInYears: number, durationInMonths: number, granularity: string, denomination: string)
	{
		this.WorkspaceId = workspaceId;
		this.Id = strategyId;
		this.TemplateId = templateId;
		this.Name = name;
		this.Description = description;
		this.PlanningHorizonInYears = planningHorizonInYears;
		this.DurationInMonths = durationInMonths;
		this.Granularity = granularity;
		this.Denomination = denomination;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Quest.Strategies.Commands.CreateCorporateProjectPlanTemplateCommandV1, TCh.Domain.Quest';
	}
}

export class DeleteCorporateProjectPlanTemplateCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Strategies.Commands.DeleteCorporateProjectPlanTemplateCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	Id: string;
	TemplateId: string;

	constructor(workspaceId: number, strategyId: string, templateId: string)
	{
		this.WorkspaceId = workspaceId;
		this.Id = strategyId;
		this.TemplateId = templateId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Quest.Strategies.Commands.DeleteCorporateProjectPlanTemplateCommandV1, TCh.Domain.Quest';
	}
}

export class UpdateCorporateProjectPlanTemplateCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Strategies.Commands.UpdateCorporateProjectPlanTemplateCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	Id: string;
	TemplateId: string;
	Name: string;
	Description: string | null;
	PlanningHorizonInYears: number;
	DurationInMonths: number;
	Granularity: string;
	Denomination: string;

	constructor(workspaceId: number, strategyId: string, templateId: string, name: string, description: string | null,
		planningHorizonInYears: number, durationInMonths: number, granularity: string, denomination: string)
	{
		this.WorkspaceId = workspaceId;
		this.Id = strategyId;
		this.TemplateId = templateId;
		this.Name = name;
		this.Description = description;
		this.PlanningHorizonInYears = planningHorizonInYears;
		this.DurationInMonths = durationInMonths;
		this.Granularity = granularity;
		this.Denomination = denomination;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Quest.Strategies.Commands.UpdateCorporateProjectPlanTemplateCommandV1, TCh.Domain.Quest';
	}
}


export class SaveViewAllProjectsPageCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Strategies.Commands.SaveViewAllProjectsPageCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	Id: string;
	Grid: string;

	constructor(workspaceId: number, strategyId: string, grid: string)
	{
		this.WorkspaceId = workspaceId;
		this.Id = strategyId;
		this.Grid = grid;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Quest.Strategies.Commands.SaveViewAllProjectsPageCommandV1, TCh.Domain.Quest';
	}
}
export class SaveViewStartedProjectsPageCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Strategies.Commands.SaveViewStartedProjectsPageCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	Id: string;
	Grid: string;

	constructor(workspaceId: number, strategyId: string, grid: string)
	{
		this.WorkspaceId = workspaceId;
		this.Id = strategyId;
		this.Grid = grid;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Quest.Strategies.Commands.SaveViewStartedProjectsPageCommandV1, TCh.Domain.Quest';
	}
}
export class SaveViewFinishedProjectsPageCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Strategies.Commands.SaveViewFinishedProjectsPageCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	Id: string;
	Grid: string;

	constructor(workspaceId: number, strategyId: string, grid: string)
	{
		this.WorkspaceId = workspaceId;
		this.Id = strategyId;
		this.Grid = grid;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Quest.Strategies.Commands.SaveViewFinishedProjectsPageCommandV1, TCh.Domain.Quest';
	}
}
export class SaveViewProposedProjectsPageCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Strategies.Commands.SaveViewProposedProjectsPageCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	Id: string;
	Grid: string;

	constructor(workspaceId: number, strategyId: string, grid: string)
	{
		this.WorkspaceId = workspaceId;
		this.Id = strategyId;
		this.Grid = grid;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Quest.Strategies.Commands.SaveViewProposedProjectsPageCommandV1, TCh.Domain.Quest';
	}
}
export class SaveViewScheduledProjectsPageCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Strategies.Commands.SaveViewScheduledProjectsPageCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	Id: string;
	Grid: string;

	constructor(workspaceId: number, strategyId: string, grid: string)
	{
		this.WorkspaceId = workspaceId;
		this.Id = strategyId;
		this.Grid = grid;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Quest.Strategies.Commands.SaveViewScheduledProjectsPageCommandV1, TCh.Domain.Quest';
	}
}